// You can namespace your keys if you want to avoid conflicts
const Storage = {
    set: (key: string, value: any) => {
        localStorage.setItem(key, JSON.stringify(value));
    },
    get: (key: string) => {
        const item = localStorage.getItem(key);
        try {
            return item ? JSON.parse(item) : null;
        } catch (error) {
            console.error('Error parsing localStorage item', error);
            return null;
        }
    },
    remove: (key: string) => {
        localStorage.removeItem(key);
    },
    clear: () => {
        localStorage.clear();
    },


    setSessionStorage: (key: string, value: any) => {
        sessionStorage.setItem(key, JSON.stringify(value));
    },
    getSessionStorage: (key: string) => {
        const item = sessionStorage.getItem(key);
        try {
            return item ? JSON.parse(item) : null;
        } catch (error) {
            console.error('Error parsing sessionStorage item', error);
            return null;
        }
    },
    removeSessionStorage: (key: string) => {
        sessionStorage.removeItem(key);
    },
    clearSessionStorage: () => {
        sessionStorage.clear();
    },
};

export default Storage; 